export enum PredefinedDateEnum {
  lastWeek = 1,
  lastMonth = 2,
  lastYear = 3
}
